import { userEndpoints } from "store/apis/userAPI/user.api"
import { IUserStatistics } from "store/apis/userAPI/user.types"
import { balanceEndpoints } from "store/apis/balanceAPI/balance.api"
import { TAGS, api } from "../../api"
import { IDailyReward } from "./types"

const dailyRewardsAPI = api.enhanceEndpoints({
  addTagTypes: [TAGS.DAILY_REWARDS]
})

export const dailyRewardsEndpoints = dailyRewardsAPI.injectEndpoints({
  endpoints: (builder) => ({
    claimDailyReward: builder.mutation<any, void>({
      query: () => ({
        url: "/daily-rewards",
        method: "PATCH"
      }),
      invalidatesTags: () => [{ type: TAGS.DAILY_REWARDS, id: "LIST" }],
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled

        dispatch(
          userEndpoints.util.updateQueryData(
            "getUserGameStatistics",
            undefined,
            (draft: IUserStatistics) => {
              draft.loginStreak += 1
              draft.lastLoginDate = new Date()
            }
          )
        )

        dispatch(
          balanceEndpoints.util.updateQueryData(
            "getBalance",
            undefined,
            () => data.newBalance
          )
        )
      }
    }),
    gatDailyRewards: builder.query<IDailyReward[], void>({
      query: () => ({
        url: "/daily-rewards",
        method: "GET"
      }),
      providesTags: (quests) =>
        quests
          ? [
              ...quests.map(({ _id }: IDailyReward) => ({
                type: TAGS.DAILY_REWARDS as const,
                id: _id
              })),
              { type: TAGS.DAILY_REWARDS, id: "LIST" }
            ]
          : [{ type: TAGS.DAILY_REWARDS, id: "LIST" }]
    })
  })
})
